export default __webpack_public_path__ + "static/media/queue.ea34e8ff.png";